exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brg-slide:not(.active) {\n\theight: 0;\n\toverflow: hidden;\n}\n\n.ng-animate.brg-slide:not(.left):not(.right) {\n\t-webkit-transition: 0s ease-in-out left;\n\ttransition: 0s ease-in-out left\n}\n", ""]);

// exports
